<!-- 导师修改详情 -->
<template>
  <div>
    <zlr-modal v-model="detailModal">
      <div style="width:960px;">
        <div class="item"
             :class="{'margin-bottom-0': !detail.menteeEditDTO && detail.uploadStatus}">
          <div class="title">
            <p>专家修改 {{curIndex | fillZero}}</p>
            <div>文件名：{{detail.expertEditDTO && detail.expertEditDTO.originFileName}}</div>
          </div>
          <pre class="content">{{detail.expertEditDTO && detail.expertEditDTO.editDesc}}</pre>
        </div>
        <template v-if="detail.menteeEditDTO"
                  :class="{'margin-bottom-0': detail.uploadStatus}">
          <div class="item">
            <div class="title">
              <p>反馈意见</p>
              <div :class="[detail.menteeEditDTO.menteeEditType === 'EXPERT'?'orange': 'green']">{{menteeStatusMap[detail.menteeEditDTO.menteeEditType]}}</div>
            </div>
            <div class="content"
                 v-html='detail.menteeEditDTO.editFeedback'></div>
          </div>
        </template>
        <div class="expert-uploaded"
             v-if="detail.uploadStatus">{{expertStatusMap[detail.uploadStatus]}}</div>
        <div class="btn-content">
          <Button type="primary"
                  class="zlr-btn-primary"
                  style="margin-right:24px;"
                  @click="handleDownload"
                  :loading="isDownlaod"
                  v-if="detail.expertEditDTO && detail.expertEditDTO.fileUrl && !detail.menteeEditDTO ">下载文书</Button>
          <Button class="zlr-btn-default"
                  @click="detailModal = false">关闭</Button>
        </div>
      </div>
    </zlr-modal>
  </div>
</template>

<script>
// components
import { ossSecretLink } from '@/api/oss'
import ZlrModal from '_c/modal/modal'
// constant
import { menteeStatusMap, expertStatusMap } from '@/constant/expert'
export default {
  name: '',
  components: {
    ZlrModal
  },
  data () {
    return {
      menteeStatusMap,
      expertStatusMap,
      detailModal: false,
      curIndex: '',
      detail: {},
      isDownlaod: false
    }
  },
  computed: {},
  mounted () { },
  methods: {
    show (data, index) {
      this.detailModal = true
      this.curIndex = index
      this.detail = data
    },
    handleDownload (url) {
      this.isDownlaod = true
      ossSecretLink({
        dir: this.detail.expertEditDTO.fileUrl
      }).then(res => {
        window.open(res.data.url)
      }).then(() => {
        this.isDownlaod = false
      })
    }
  }
}
</script>
<style lang='less' scoped>
.item {
  margin-bottom: 40px;
  .title {
    margin-bottom: 24px;
    p {
      font-size: 24px;
      color: rgba(0, 0, 0, 0.85);
      line-height: 36px;
      margin-bottom: 4px;
    }
    div {
      font-size: 14px;
      color: rgba(0, 0, 0, 0.85);
      line-height: 24px;
    }
    .orange {
      color: #ffa940;
    }
    .green {
      color: #06ae3e;
    }
  }
  .content {
    font-size: 14px;
  }
  &.margin-bottom-0 {
    margin-bottom: 0;
  }
}
.expert-uploaded {
  font-size: 14px;
  color: #06ae3e;
  line-height: 24px;
  padding-top: 24px;
  padding-bottom: 32px;
}
.padding-top-0 {
  padding-top: 0;
}
</style>
